const secondsUntilEndOfDayGMT = (): number => {
  const now = new Date();
  const nowUTC = now.getTime();
  const endOfDayUTC = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    23,
    59,
    59,
    999,
  );

  const millisecondsLeft = endOfDayUTC - nowUTC;
  const secondsLeft = Math.floor(millisecondsLeft / 1000);

  return secondsLeft;
};

export { secondsUntilEndOfDayGMT };
